import {
  traineeList,
  traineeLetter,
  traineeDocuments,
  traineeCourses,
  traineeAssessment,
  traineeCertificates
} from "constants/trainee";

const initialState = {
  traineeList: {},
  traineeCourses: {},
   traineeAssessment: {},
  traineeCertificates: {},
};

const trainees = (state = initialState, action) => {
  switch (action.type) {
    case traineeList:
      return { ...state, traineeList: action.payload };

    case traineeLetter:
      return { ...state, traineeLetter: action.payload };

    case traineeDocuments:
      return { ...state, traineeDocuments: action.payload };

    case traineeCourses:
      return { ...state, traineeCourses: action.payload };
    case traineeAssessment:
      return { ...state, traineeAssessment: action.payload };
    case traineeCertificates:
  return { ...state, traineeCertificates: action.payload };
    default:
      return state;
  }
};

export default trainees;
